import Select from "components/shared/select";
import React, { useState } from "react";
import { addToFamily, removeFromFamily } from "sources/trailerTypes";

export default function TrailerFamilyForm(props) {
    const [trailerFamilyId, setTrailerFamilyId] = useState(props.value);
    const [loading, setLoading] = useState(false);
    const { trailerTypeId } = props;
    const handleSave = () => {
        setLoading(true);
        const resolver = (res) => {
            if (res) {
                props.back();
                props.mergeParams();
            }
            setLoading(false);
        };
        if (trailerFamilyId) {
            addToFamily({ familyTypeId: trailerFamilyId, trailerTypeId }).then(resolver);
        } else if (props.value) {
            removeFromFamily({ trailerTypeId }).then(resolver);
        }
    };

    return (
        <div className={loading ? "loading" : ""}>
            <div className="form-group">
                <Select
                    inputProps={{ name: "trailerFamilyId" }}
                    options={props.trailerFamilyTypes}
                    value={trailerFamilyId}
                    onChange={({ value }) => setTrailerFamilyId(value)}
                    menuPortalTarget={document.body}
                />
            </div>
            <div className="btn btn-sm btn-brand float-right" onClick={handleSave}>
                Сохранить
            </div>
        </div>
    );
}
